import { Provider } from '@angular/core';

import { FactoryManageVacationsRepositoryImpl } from '@app/data/repositories/manage-vacations/factory/factory-manage-vacations.repository';
import { FACTORY_MANAGE_VACATIONS_REPOSITORY } from '@app/domain/repositories/manage-vacations/factory/factory-manage-vacations.repository.contract';

export const factoryManageVacationsRepositoryProvider: Provider = {
  provide: FACTORY_MANAGE_VACATIONS_REPOSITORY,
  useClass: FactoryManageVacationsRepositoryImpl
};
